import { useMemo } from 'react';
import { Cell, Pie, PieChart } from 'recharts';
import { SIZE } from './PieChart/constants';
import { PieChartData } from './types';

const DONUT_WIDTH = 10;
const PADDING = 10;

const OUTER_RADIUS = SIZE / 2 - PADDING;
const INNER_RADIUS = OUTER_RADIUS - DONUT_WIDTH;

export const DashboardPie = ({ data }: { data: PieChartData[] }) => {
    const pieData = useMemo(
        () =>
            data.map((item, index) => ({
                value: item.value,
                key: index,
                color: item.color,
            })),
        [data]
    );

    return (
        <PieChart width={SIZE} height={SIZE}>
            <Pie outerRadius={OUTER_RADIUS} innerRadius={INNER_RADIUS} dataKey="value" data={pieData}>
                {pieData.map((item) => (
                    <Cell key={item.key} fill={item.color} />
                ))}
            </Pie>
        </PieChart>
    );
};
